var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['mb-2', {'white--text': _vm.dark}]},[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('v-divider',{attrs:{"dark":_vm.dark}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }